/* ===== Role Selection UI ===== */
import { $ } from '../utils/helpers.js?v=82.86';
import { getCurrentSettings } from '../services/settings.js?v=82.86';

// Update role cards based on user permissions
export function updateRoleCards() {
  const currentSettings = getCurrentSettings();
  const adminCard = document.getElementById('adminRoleCard');
  const clientCard = document.getElementById('clientRoleCard');

  // Check if user has admin access (has admin password set)
  const hasAdminAccess = true; // PIN-ul nu mai e necesar pentru Modul client

  if (adminCard) {
    // For now, admin is always accessible if logged in
    // You can add more checks here if needed
    adminCard.classList.remove('disabled');
  }

  if (clientCard) {
    if (!hasAdminAccess) {
      clientCard.classList.add('disabled');
      const subtitle = clientCard.querySelector('.mode-card-subtitle');
      if (subtitle) {
        subtitle.textContent = 'Setează mai întâi PIN-ul ADMIN în Panou pentru a accesa modul Client.';
      }
    } else {
      clientCard.classList.remove('disabled');
      const subtitle = clientCard.querySelector('.mode-card-subtitle');
      if (subtitle) {
        subtitle.textContent = 'Experiență digitală pentru clienți';
      }
    }
  }
}
